import React from 'react'
import ReactDOM from 'react-dom'

import App from "./LoginComponents/LoginApp"

ReactDOM.render(<App />, document.getElementById('root'))